import type React from 'react'
import { forwardRef } from 'react'

import css from './Group.module.scss'

const Group = forwardRef<HTMLDivElement, { children?: React.ReactNode }>(
  ({ children }, ref) => (
    <div ref={ref} className={css.container}>
      {children}
    </div>
  )
)

export default Group
